module.exports = __webpack_public_path__ + "static/default-avatar.337dbfb3.png";